enum Attachment {
  HEIC = 'heic', // iOS HEIC images
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
  UNKNOWN = 'unknown',
}

export default Attachment;
